//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const staticAPI = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getBannerText(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };

      let res = await fetch(
        `${config.host}/cdr-panel/static/banner-text`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function uploadBanner(file, type) {
    try {
      const formData = new FormData();
      formData.append('file', file); 
      const obj = {
        method: "POST",
        body: formData,
        credentials: 'include', 
        // headers: {
        
        //   "Content-Type": "multipart/form-data", // Not required because FormData sets the content type automatically
        // },
      };
  
      const res = await fetch(`${config.host}/cdr-panel/static/upload/${type}`, obj);
  
      return handleResponse(res); 
    } catch (err) {
      handleError(err); 
    }
  }

  return {
    getBannerText,
    uploadBanner
  };
};

export default staticAPI;
